import React from 'react'
import Details from '../components/Details';
import Navbar from '../components/Navbar';
import Footer from './../components/Footer/Footer';

const Contact = () => {
  return (
    <>
      <Navbar/>
      <Details />
      <Footer/>
    </>
  )
}

export default Contact